/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { Dialog } from "@mui/material";
import SimplicityDialogContent from "components/simlplicity-dialog-content/index";
import { ComponentPlacements } from "cms/components/layout/reuse/placements-dialog/component-placements";
import { useComponentConfig } from "cms/models/hooks/use-components-config";

const ComponentPlacementsDialog = (props) => {
    
    const {
        // fieldName,
        label,
        component,
        open,
        onClose,
    } = props;
    const { type } = component || {};
    const componentConfig = useComponentConfig(type);
    const title = componentConfig?.label;
    
    return (
        <Fragment>
            <Dialog
                open={open}
                onClose={onClose}
            >
                <SimplicityDialogContent
                    title={"Component reuse details"}
                    height={"450px"}
                    compact={true}
                    description={`<strong>Component:</strong> ${label || "Untitled"} (${title})`}
                    handleClose={onClose}
                >
                    <ComponentPlacements
                        component={component}
                    />
                </SimplicityDialogContent>
            </Dialog>
        </Fragment>
    );
};

export { ComponentPlacementsDialog };
